import $ from 'jquery'

export function initialise() {
  $('body').on('submit', 'form[data-ajax-form]', function(event) {
    event.preventDefault()

    var $form = $(event.currentTarget)
    var formAction = $form.prop('action')
    var reCAPTCHA_sitekey = $form.attr('data-recaptcha-sitekey')
    var reCAPTCHA_action = $form.attr('data-recaptcha-action')
    var formData = $form.serialize()

    $form
      .find('button[type="submit"]')
      .prop('disabled', true)
      .text('Please wait...')

    if (reCAPTCHA_sitekey && reCAPTCHA_action && window.grecaptcha) {
      grecaptcha.ready(() => {
        grecaptcha.execute(reCAPTCHA_sitekey, { action: reCAPTCHA_action }).then(token => {
          formData += '&recaptcha_token=' + encodeURIComponent(token)
          postData(formAction, formData)
        })
      })
    } else {
      postData(formAction, formData)
    }
  })
}

function postData(url, formData) {
  // post ajax form and update content areas
  $.post(url, formData, function(response, status, xhr) {
    var scrollHeight = document.body.scrollHeight
    $('<div></div>')
      .append(response)
      .find('[data-ajax-form-target]')
      .each(function() {
        var $el = $(this)
        $('[data-ajax-form-target="' + $el.data('ajax-form-target') + '"]').replaceWith($el)
        $el.trigger('ajax.replace')
      })
    document.body.scrollTop += document.body.scrollHeight - scrollHeight
  })
}
